'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_samples$002e$002dValidation$0024package$0024$002dIron$002dSample$00241 from "./samples.-Validation$package$-Iron-Sample$1.js";
var $p;
/** @constructor */
function $c_Lsamples_Validation$package$IronSample$3$() {
}
export { $c_Lsamples_Validation$package$IronSample$3$ as $c_Lsamples_Validation$package$IronSample$3$ };
$p = $c_Lsamples_Validation$package$IronSample$3$.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lsamples_Validation$package$IronSample$3$;
/** @constructor */
function $h_Lsamples_Validation$package$IronSample$3$() {
}
export { $h_Lsamples_Validation$package$IronSample$3$ as $h_Lsamples_Validation$package$IronSample$3$ };
$h_Lsamples_Validation$package$IronSample$3$.prototype = $p;
$p.b = (function() {
  return "IronSample";
});
$p.UI = (function(x$0) {
  return new $j_samples$002e$002dValidation$0024package$0024$002dIron$002dSample$00241.$c_Lsamples_Validation$package$IronSample$1(x$0.g(0), x$0.g(1), x$0.g(2), (+x$0.g(3)), x$0.g(4), x$0.g(5));
});
$p.y = (function(p) {
  return this.UI(p);
});
var $d_Lsamples_Validation$package$IronSample$3$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lsamples_Validation$package$IronSample$3$, "samples.Validation$package$IronSample$3$", ({
  rf: 1,
  e: 1,
  g: 1
}));
export { $d_Lsamples_Validation$package$IronSample$3$ as $d_Lsamples_Validation$package$IronSample$3$ };
